<script>
    import ModalEdit from '../../layouts/ModalEdit.vue';
    import PersonService from './PersonService.js';
    import OrderByPersonWidget from '../shop/order/OrderByPersonWidget.vue'

    export default {
        extends: ModalEdit,
        components: {
            'order-person-widget': OrderByPersonWidget
        },
        name: 'modal',
        props: ['value','visible'],
        data: function () {
            return {
                config: null,
                internalValue: '',
                currency: ''
            }
        },
        created: function() {

            this.internalValue = this.value;

            this.getResource().get(this.internalValue.id).then((response) => {
                this.internalValue = response.data
                console.log('RESOURCE', response.data)
            })

            this.initialize();

        },
        methods: {
            close() {
                this.$emit('close');
            },
            validate(){

            },
            getResource: function(){
                return PersonService
            },
        }
    };
</script>
<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="close()"></div>
            <div class="modal"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription">
                <article>
                    <header
                            class="modal-header"
                            id="modalTitle"
                            style="background:none;">
                        <figure>
                          <img :src="$iconFolder + 'user-man.svg'" v-if="!internalValue.picture && internalValue.gender != 'f'"/>
                          <img :src="$iconFolder + 'user-woman.svg'" v-if="!internalValue.picture && internalValue.gender == 'f'"/>
                          <img v-if="internalValue.picture" :src="internalValue.picture.url+'/fit/100x100'"/>
                        </figure>
                        <div>
                            <h1>{{ internalValue.firstname }} {{ internalValue.lastname }}</h1>
                            <p>{{ internalValue.email }}</p>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="close()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                        </div>
                    </header>
                    <main>

                      <tabs :options="{ useUrlFragment: false }">
                        <tab name="Détail">

                          <fieldset>
                            <h3>Information</h3>
                            <p class="headline"></p>

                            <group-line-2>
                              <form-text label="Prénom" v-model="internalValue.firstname" readonly="true"></form-text>
                              <form-text label="Nom" v-model="internalValue.lastname" readonly="true"></form-text>
                            </group-line-2>

                            <form-text label="E-mail" v-model="internalValue.email" readonly="true"></form-text>
                            <group-line-2>
                              <form-text label="Téléphone mobile" v-model="internalValue.phone_mobile" readonly="true"></form-text>
                              <form-text label="Téléphone" v-model="internalValue.phone" readonly="true"></form-text>
                            </group-line-2>

                          </fieldset>

                        </tab>
                        <tab name="Historique">

                          <fieldset>
                            <h3>Information</h3>
                            <p class="headline"></p>
                            <order-person-widget :person_id="internalValue.id"></order-person-widget>
                          </fieldset>

                        </tab>
                      </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>


// WEBPACK FOOTER //
// src/modules/person/ModalDetail.vue